import { GlobalConfigType, setGlobalConfig } from 'actions'
import { LayoutLoading } from 'components/LayoutLoading'
import { OptionList } from 'components/OptionList'
import { SettingKey } from 'config'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { getSetting, updateSetting } from 'services'
import { svgLoading } from 'stories/assets'
import { Button } from 'stories/components'
import { IOptionType } from 'utils/general'

export const DocumentCategories = () => {
  const dispatch = useDispatch()

  const [isLoading, setLoading] = useState(true)
  const [values, setValues] = useState<IOptionType[]>([])

  useEffect(() => {
    getSetting(SettingKey.DOCUMENT_CATEGORY_OPTIONS)
      .then((data) => {
        const { value } = data
        if (!value) return

        setValues(JSON.parse(value))
      })
      .finally(() => setLoading(false))
  }, [])

  const onSubmit = async () => {
    setLoading(true)
    const savingValues = values.filter((value) => value.value !== null)
    await updateSetting(SettingKey.DOCUMENT_CATEGORY_OPTIONS, JSON.stringify(savingValues))
    setValues(savingValues)
    dispatch(setGlobalConfig(GlobalConfigType.DocumentCategory, savingValues))
    setLoading(false)
    toast('Document categories have been updated.', { type: 'success' })
  }

  return (
    <div>
      <h1 className="text-2xl font-bold flex items-center pb-2">
        Document Categories
        {isLoading && (
          <span className="ml-3">
            <img src={svgLoading} className="inline w-6 h-6 text-white animate-spin" />
          </span>
        )}
      </h1>
      <p className="text-sm text-gray-500 pb-5">
        These categories are used wherever documents are filed - the loan documents tab, loan submission, post closing
        and loan conditions. Hide a category to retire it without changing documents already filed under it.
      </p>

      <div className="relative overflow-auto shadow-md sm:rounded-lg">
        <LayoutLoading show={isLoading} />
        <OptionList values={values} onChange={setValues} />
      </div>

      <div className="block text-center mt-5">
        <Button onClick={onSubmit} className="px-10" loading={isLoading}>
          Update
        </Button>
      </div>
    </div>
  )
}
